import React from 'react';
import Faq from 'react-faq-component';
import Slider from '../NetflixSlider'
import {  Link } from 'react-router-dom'
import InstructordCard from '../instructor/InstructorCard';
import Objetico from '../curso/Objetivo';
import moment from 'moment';
import 'moment/locale/es';
import {
    Card,
    Item,
  Container,
  Divider,
  Dropdown,
  Grid,
  Header,
  Image,
    Label,
  List,
    Icon, 
    Input,
    Button,
  Menu,
    Form, 
    Radio, 
    Transition, 
  Segment,
    Visibility
} from 'semantic-ui-react';

moment.locale('es');


/*

          <Button basic color="orange" size="small">
                <Icon.Group size='large' >
                    <Icon name='user' color="orange" />
                    <Icon corner name='add' color="orange" />
                </Icon.Group>
                &nbsp;{strings?strings["SolicitaInscripcion"]:""}
            </Button>
  
*/


const Pago = ({content, curso,  user, onInscribir, faq, overlayFixed=true, strings }) => {
  let dos=[];

   const product = {
        descripcion: "curso 1",
        price: "1" 
   };
   

    let datos=[
                  {
                    id: 5,
                    url:"/cursoplay/",
                    image: '/images/capsula.jpeg',
                    imageBg: '/images/capsula.jpeg',
                    title: 'Cápsulas de Control de Calidad'
                      , desc:"Mi descripcnp ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque"+
                          "et euismod ligula. Morbi mattis pretium eros, ut mollis leo tempus"+
                          "eget. Sed in dui ac ipsum feugiat ultricies. Phasellus vestibulum enim"+
                          "quis quam congue, non fringilla orci placerat. Praesent sollicitudin"

                  },
                  {
                    id: 6,
                    url:"/cursoplay/",
                    image: '/images/premium.jpg',
                    imageBg: '/images/premium.jpg',
                    title: 'Cursos Premium Belt'
                      , desc:"Mi descripcnp ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque"+
                          "et euismod ligula. Morbi mattis pretium eros, ut mollis leo tempus"+
                          "eget. Sed in dui ac ipsum feugiat ultricies. Phasellus vestibulum enim"+
                          "quis quam congue, non fringilla orci placerat. Praesent sollicitudin"

                  },
                  {
                    id: 7,
                      url:"/cursoplay/",
                    image: '/images/manejo.jpeg',
                    imageBg: '/images/manejo.jpeg',
                    title: 'Manejo de los sistemas Green Belt y Black Belt'
                      , desc:"Mi descripcnp ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque"+
                          "et euismod ligula. Morbi mattis pretium eros, ut mollis leo tempus"+
                          "eget. Sed in dui ac ipsum feugiat ultricies. Phasellus vestibulum enim"+
                          "quis quam congue, non fringilla orci placerat. Praesent sollicitudin"

                  }
        ];
    return (
    



    <Segment basic style={{ marginTop: '4em'}}>
    
<Segment basic style={{   marginLeft: '2em', marginRight: '2em' }}>
    
        
             
        <Segment color="blue" inverted>
            <Header as='h3' >
                {strings?strings["SolicitaInscripcion"]:""}
            </Header>
        </Segment>
        <Item.Group>
        <Item>
      <Item.Image size='big' src={curso.imageBg} />

      <Item.Content>
        <Item.Header as='a'>{curso.title}</Item.Header>
        <Item.Meta>{strings?strings["Descripcion"]:""}</Item.Meta>
        <Item.Description>
          {curso.desc} </Item.Description>
        
        
        
        <Item.Extra>{strings?strings["FechaInicio"]:""}: {moment(curso.fechaInicio).format('LL')}</Item.Extra>
        {curso.costoFloat>=0?     
        <Item.Extra>{strings?strings["Costo"]:""}: {curso.costo} USD</Item.Extra>
        :
        ""
        }
        <Item.Extra>
        
             
        {curso.costoFloat>=0?     
        <p>
        {strings?strings["ParaSolicitar"]:""}: &nbsp;&nbsp;&nbsp;
           
           {user==null?  
               
  
            <Link to="/miespacio" ><Button color="teal" >{strings?strings["Ingresar"]:""}</Button></Link>
   
               
          :
            <>
            {curso.costoFloat>0?
                <Button basic color="orange" size="small" onClick={()=>onInscribir("2")}>
                    <Icon.Group size='large' >
                        <Icon name='user' color="blue" />
                        <Icon corner name='add' color="blue" />
                    </Icon.Group>
                    &nbsp;{strings?strings["Inscribete"]:""}
                </Button>
            :
                <Button basic color="blue" size="small" onClick={()=>onInscribir("1")}>
                    <Icon.Group size='large' >
                        <Icon name='user' color="blue" />
                        <Icon corner name='add' color="blue" />
                    </Icon.Group>
                    &nbsp;{strings?strings["Inscribete"]:""}
                </Button>
            }
            </>
        }
        </p>
        
        :
        
            <Button basic color="orange" size="small" onClick={()=>onInscribir("2")}>
                    <Icon.Group size='large' >
                        <Icon name='user' color="orange" />
                        <Icon corner name='add' color="orange" />
                    </Icon.Group>
                   Pre-inscripción
                </Button>
        
        
        }
           
        </Item.Extra>
       
      </Item.Content>
    </Item>
        </Item.Group>
       
         
    
      </Segment>  
      
      
     
      <Segment inverted vertical style={{ margin: '5em 0em 0em', padding: '5em 0em' }}>
      <Container >
        <Grid divided inverted stackable>
          <Grid.Column width={1}>
            <Header inverted as='h4' content='' />
            <List link inverted>
              <List.Item>                
                <a target="_blank" href='https://www.facebook.com/QualityConsultingLatinoamerica/'>
                  <List.Icon name='facebook square' size="big" />
                  </a> 
                </List.Item>

              <List.Item>
                <a target="_blank" href='https://www.linkedin.com/company/quality-consulting-asesores'>
                  <List.Icon name='linkedin square' size="big" />
                  </a> 
                </List.Item>

                <List.Item>
                <a target="_blank" href='https://www.instagram.com/qualityacademics/?hl=es-la'>
                  <List.Icon name='instagram' size="big" />
                  </a> 
                </List.Item>


                <List.Item>
                <a target="_blank" href='https://www.youtube.com/c/QualityConsulting-QualityAcademics'>
                  <List.Icon name='youtube square' size="big" />
                  </a> 
                </List.Item>
                  
                <List.Item>
                <a target="_blank" href='https://twitter.com/Q_Academics/'>
                  <List.Icon name='twitter square' size="big" />
                  </a> 
                </List.Item>  



            </List>
          </Grid.Column>

        <Grid.Column width={3}>
            <Header inverted as='h4' content={strings?strings["QuienesSomos"]:""} />
            <List link inverted>
            
               
            <List.Item>
              <List.Content>
                <List.Icon name='linkify' />
                <a target="_blank"  href='https://www.qsc.com.mx/'>Quality Consulting</a>
              </List.Content>
            </List.Item>
              
            </List>
          </Grid.Column>


          <Grid.Column width={2}>
            <Header inverted as='h4' content={strings?strings["Nuestrasherramientas"]:""} />
            <List link inverted>
            
               
            <List.Item>
              <List.Content>
                <a target="_blank"  href='https://www.qsc.com.mx/green-belt/'>Green Belt</a>
              </List.Content>
            </List.Item>

<List.Item>
              <List.Content>
                <a target="_blank"  href='https://www.qsc.com.mx/black-belt/'>Black Belt</a>
              </List.Content>
            </List.Item>

<List.Item>
              <List.Content>
                <a target="_blank"  href='https://www.qsc.com.mx/orange-belt/'>Orange Belt </a>
              </List.Content>
            </List.Item>

<List.Item>
              <List.Content>
                <a target="_blank"  href='https://www.qsc.com.mx/premium-belt/'>Red Belt</a>
              </List.Content>
            </List.Item>

           <List.Item>
              <List.Content>
                <a target="_blank"  href='https://www.qsc.com.mx/red-belt/'>Premium belt</a>
              </List.Content>
            </List.Item>
                
            <List.Item>
              <List.Content>
                <a target="_blank"  href='https://www.one.green-belt.com.mx'>Green belt one</a>
              </List.Content>
            </List.Item>    
                
            <List.Item>   
                    <List.Content>    
                    <a target="_blank"  href={"/info/reconocimientoManual?id=31"}  target="_black">Constancia</a>
                    </List.Content>    
            
               </List.Item>      
                
                    
                    


            </List>
          </Grid.Column>
          
          

<Grid.Column width={3}>
            <Header inverted as='h4' content={strings?strings["QCC"]:""} />
            <List link inverted>
            
               
            <List.Item>
              <List.Icon name='marker' />
              <List.Content>Cra. 13 # 98-70 of.604 edificio OCHIC. Bogotá, Colombia</List.Content>
            </List.Item>


<List.Item>
              <List.Icon name='phone square' />
              <List.Content>{strings?strings["Telefonos"]:""}: (57)3162968728</List.Content>
            </List.Item>

<List.Item>
              <List.Icon name='mail' />
                 <List.Content> <a href='mailto:contacto@qsc.com.mx'>contacto@qsc.com.mx</a>
               </List.Content>
            </List.Item>
              
            </List>
          </Grid.Column>



<Grid.Column width={4}>
            <Header inverted as='h4' content={strings?strings["QCM"]:""} />
            <List link inverted>
            
               
            <List.Item>
              <List.Icon name='marker' />
              <List.Content>Calzada de la Viga 1750 int. 21, Colonia Héroes de Churubusco, Alcaldía Iztapalapa (Ciudad de México 01090)</List.Content>
            </List.Item>


<List.Item>
              <List.Icon name='phone square' />
              <List.Content>{strings?strings["Telefonos"]:""}: 0155 5705 9011 / 9012 / 9013 / 9014</List.Content>
            </List.Item>

<List.Item>
              <List.Icon name='mail' />
                 <List.Content> <a href='mailto:contacto@qsc.com.mx'>contacto@qsc.com.mx</a>
               </List.Content>
            </List.Item>
              
            </List>
          </Grid.Column>






        </Grid>

         
        
      </Container>
    </Segment>

    

  </Segment>
                 
               
);
}
 

export default Pago